import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimelinePreviewComponent } from 'src/app/pages/common/components/timeline-preview/timeline-preview.component';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';



@NgModule({
  declarations: [TimelinePreviewComponent],
  exports:[TimelinePreviewComponent],
  imports: [
    CommonModule,
    TranslateModule,
    IonicModule
  ]
})
export class TimelinePreviewModule { }
